/**
 * What the screen shouts when the reader gets one right (SPEC-007 D-60).
 *
 * A run of correct answers that is always answered with the word "correct" is a
 * run that stops feeling like anything by the fourth round. Eight words, walked
 * in order by the streak, so a reader who is doing well is TOLD they are doing
 * well in a way that changes — and the change is what carries the sense of a run
 * building rather than repeating.
 *
 * BY STREAK, NOT AT RANDOM, and for the same two reasons every other
 * deterministic pick in this game has: random repeats inside a run about an
 * eighth of the time, which reads as the app having run out of things to say;
 * and a test can name the word a given streak gets, where a random one can only
 * be asserted as "one of these eight".
 *
 * The list is MESSAGE KEYS rather than words. Every one of these is chrome the
 * reader reads, so it goes through `t()` and lives in every catalogue — and this
 * module stays pure, which is what lets the order be a decision somebody can
 * argue with rather than a string table inside a component.
 *
 * The ORDER is deliberate: it opens flat and gets louder. "Correct" is the right
 * thing to say to somebody who has answered one question, and "Untouchable" is
 * the wrong thing to say to them; by the time the list reaches it they have
 * eight in a row. Past eight it wraps, because a ninth tier of praise is a word
 * nobody has, and the streak counter beside it is already saying the number.
 */
export const DUEL_PRAISE = [
    'correct',
    'nice',
    'spotOn',
    'nailedIt',
    'sharp',
    'flawless',
    'unstoppable',
    'untouchable',
];

/** The message key for a streak of `streak` correct answers. */
export function praiseKey(streak) {
    const index = Math.max(0, Math.trunc(streak) || 0) - 1;

    return `duel.praise.${DUEL_PRAISE[Math.max(0, index) % DUEL_PRAISE.length]}`;
}
